import style from "./style.module.scss";
import useFormat from "../../hooks/utils/useFormat";
import { useNavigate } from "react-router-dom";

export default function BudgetsList(props) {
  const { formatDate } = useFormat();
  const navigate = useNavigate();
  const { budgets } = props;
  return (
    <div className={style.budget_list} {...props}>
      {budgets
        ?.filter(__budget => !!__budget.active)
        ?.map(__budget => (
          <div
            className={`${style.budget_item} ${!!__budget.main ? style.budget_main : ""}`}
            onClick={() => {
              navigate(`/business/budget/${__budget.commercial_id}/${__budget.id}`);
            }}
          >
            <p className={`${style.budget_title} d-flex justify-content-between m-0`}>
              <b>{__budget.title || ""}</b>
              {!!__budget.main ? <span>(Principal)</span> : ""}
            </p>
            <p className="op-5">{__budget?.description || ""}</p>
            {__budget?.packageColection?.length > 0 && (
              <>
                <p className="mt-2">
                  <b>Pacotes:</b>
                </p>
                {__budget?.packageColection
                  ?.filter(__package => !!__package.active)
                  ?.map(__package => (
                    <p className={style.budget_package}>
                      <b>{__package.title || ""}</b>
                      <span className="small-label">{` (${__package.number_trainees} formandos)`}</span>:
                      {__package?.events?.map((__event, __event_i) => (
                        <span>
                          {__event_i > 0 ? ", " : " "}
                          {__event.name}
                        </span>
                      ))}
                    </p>
                  ))}
              </>
            )}
            {__budget?.packageSingleColection?.length > 0 && (
              <>
                <p>
                  <b>Avulsos:</b>
                </p>
                {__budget?.packageSingleColection
                  ?.filter(__single => !!__single.active)
                  ?.map(__single => (
                    <p className={style.budget_package}>
                      <b>{__single?.events?.name || ""}</b>
                      <span className="small-label">{` (${__single.number_trainees} formandos)`}</span>
                    </p>
                  ))}
              </>
            )}
            <p className="small-label mt-2">{formatDate(__budget.updated_at, 1)}</p>
          </div>
        ))}
    </div>
  );
}
